import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const EmployeeGrievanceProcedure = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  grievanceOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Employee_Grievance_Procedure.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Employee Grievance Procedure</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This procedure outlines the steps for employees to raise concerns or complaints (grievances) relating to their employment, ensuring fair and timely resolution.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        Applies to all employees and workers of {clientName || "the Company"}.
      </p>

      <h4 className="section-title">3. What is a Grievance?</h4>
      <p className="section-content">
        A grievance is any concern, problem, or complaint raised by an employee relating to their work, working conditions, relationships, or treatment at work.
      </p>

      <h4 className="section-title">4. Raising a Grievance</h4>
      <ul>
        <li>Employees should initially attempt to resolve concerns informally by discussing with their immediate supervisor or manager.</li>
        <li>If unresolved, a formal grievance should be submitted in writing to the HR department or designated grievance officer.</li>
      </ul>

      <h4 className="section-title">5. Grievance Procedure</h4>
      <ul>
        <li><strong>Acknowledgment:</strong> The grievance will be acknowledged in writing within 5 working days.</li>
        <li><strong>Investigation:</strong> An impartial investigation will be conducted, including gathering relevant information and speaking to involved parties.</li>
        <li><strong>Meeting:</strong> The employee will be invited to a grievance meeting to discuss the issue.</li>
        <li><strong>Outcome:</strong> A decision will be communicated in writing within 10 working days of the meeting.</li>
        <li><strong>Appeal:</strong> If dissatisfied, the employee can appeal the decision within 5 working days, leading to a further review by senior management.</li>
      </ul>

      <h4 className="section-title">6. Confidentiality</h4>
      <p className="section-content">
        All grievances will be handled confidentially to the extent possible, respecting the privacy of all parties involved.
      </p>

      <h4 className="section-title">7. Protection from Victimisation</h4>
      <p className="section-content">
        Employees raising grievances in good faith will not be subjected to any form of victimisation or retaliation.
      </p>

      <h4 className="section-title">8. Record Keeping</h4>
      <p className="section-content">
        Records of grievances, investigations, and outcomes will be securely maintained in line with data protection legislation.
      </p>

      <h4 className="section-title">9. Review of Procedure</h4>
      <p className="section-content">
        This procedure will be reviewed regularly and updated as necessary to ensure fairness and compliance with employment law.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>HR Department:</strong> {hrContact || "[Insert Contact Number]"}</li>
        <li><strong>Grievance Officer:</strong> {grievanceOfficerContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read and understood the Employee Grievance Procedure and agree to follow the process outlined.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This procedure has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default EmployeeGrievanceProcedure;
